import { Box, Bubbles, Col, H1, Span } from '@landsbankinn/ui-kit';
import { type ReactNode } from 'react';
import { useScreenSize } from 'src/hooks/useScreenSize';

type LoadingProps = {
  title: string;
  description: string | ReactNode;
};
export function Loading({ title, description }: LoadingProps) {
  let text: ReactNode;
  if (typeof description === 'string') {
    text = <Span fontVariant="body">{description}</Span>;
  } else {
    text = description;
  }
  const { isMobile } = useScreenSize();

  return (
    <Col
      textAlign="center"
      height={isMobile ? '400' : '580'}
      mainAxisAlignment="center"
    >
      <H1 fontVariant={isMobile ? 'h3' : 'h2'} paddingBottom="24">
        {title}
      </H1>
      <Box>{text}</Box>
      <Bubbles variant="bounce" size="large" />
    </Col>
  );
}
